import React from 'react'
import "./style.css"

function TentangKami() {
  return (
    <div>
        <div className='container-image'>
            <div className='container-sub'>
                <div className='content-item'>
                    <h1>TENTANG KAMI</h1>
                    <p>Percepatan penurunan stunting, baik itu intervensi gizi spesifik maupun 
                      intervensi gizi sensitif, merupakan bagian program pada Bidang Health 
                      di Yayasan Anak Bangsa Bisa 2.0. Intervensi gizi spesifik adalah 
                      intervensi yang berhubungan dengan peningkatan gizi dan kesehatan, 
                      sementara intervensi gizi sensitif adalah intervensi pendukung seperti 
                      penyediaan air bersih dan sanitasi. Menurut berbagai literatur, intervensi
                      gizi sensitif ini memiliki kontribusi lebih besar yakni 70% 
                      dalam upaya penurunan stunting. Jumlah penderita stunting di 
                      Indonesia sendiri terus mengalami peningkatan. Adapun maksud 
                      pembuatan website ini, untuk mengedukasi para Ibu dan masyarakat 
                      akan pentingnya pencegahan stunting. Dan juga dibutuhkan peran para 
                      anak muda untuk membantu mensosialisasikan “Pentingnya pencegahan stunting 
                      pada anak” melalui website yang telah dibuat. 
                      Gerakan mensosialisasikan pencegahan stunting ini menjadi salah satu strategi penurunan jumlah penderita stunting dengan berkolaborasi dengan Pegawai Puskesmas yang ahli di bidang ini. Tanpa ada penyimpangan dengan visi&misi yang sudah kami tetapkan.
                    </p>
                </div>
            </div>
        </div>
    </div>
  )
}

export default TentangKami